const CONSTATATION_CHARGE = {
  title: 'Constater la charge',
  breadcrumb: {
    liste: 'Constater la charge',
    racine: 'Accueil',
  },
  actions: {
    constatationCharge: 'Constater la charge',
  },
  tab: {
    echeance: 'Echéance',
    code: 'Code bail',
    dateDebut: 'Début période',
    dateFin: 'Fin période',
    montantHt: 'Montant HT',
    montantRestantAConstaterHt: 'Montant à constater HT',
    montantTtc: 'Montant TTC',
    bailleur: 'Bailleur',
  },
  messages: {
    success: {
      generation: 'La charge a été constatée avec succès.',
    },
    error: {
      noPaymentType: 'Le mode de paiement est obligatoire pour l\'échéance du bail "{code}"',
      noPaymentTypeNoCode: 'Le mode de paiement est obligatoire pour l\'échéance d\'un bail',
      problemOccurred: 'Un problème est survenu',
    },
  },
  datePivot: 'Date pivot : ',
  dateEcheance: 'Dates d\'échéances',
  codeBail: 'Code bail',
  dateDebut: 'Dates début période',
  dateFin: 'Dates fin période',
  bailleur: 'Bailleur',
  dateComptable: 'Date comptable',
  titlePopupConstatation: 'Constater la charge',
  error: {
    dateComptable: 'Date comptable',
  },
};

export default CONSTATATION_CHARGE;
